import { useToken } from "../../slices/common/selectors";
import { useGetUserQuery } from "./endpoints";

export const useUser = () => {
  const token = useToken();
  return useGetUserQuery(undefined, { skip: !token });
};
